import React, { Component } from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import {Helmet} from 'react-helmet';
import ReactGA from 'react-ga';

import 'bootstrap/dist/css/bootstrap.min.css';
//import './ddip.scss';
import './ddip.css';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Header from './components/header';
import Navigation from './components/navigation';
import Footer from './components/footer';
import Scenarios from './components/Scenarios';
import Scenario from './components/Scenario';
import Phase from './components/Phase';
//import { DataContext } from './contexts/dataContext';
import ScrollToTop from './components/scrollToTop';
//import {About, Resources, Terms} from './pages';
import About from './pages/about';
import Resources from './pages/resources';
import Terms from './pages/terms';
import Framework from './pages/framework';
import Error404 from './pages/404';
import * as Strings from './constants';

// Initialise Google Analytics
ReactGA.initialize('UA-157458781-1');
ReactGA.pageview(window.location.pathname + window.location.search);

const Home = () => (
  <Container fluid className="App home">
    <Header />
    <Scenarios />
    <Footer />
  </Container>
)

const Page = ({ match }) => {
  const components = {
    about: About,
    resources: Resources,
    terms: Terms,
    framework: Framework,
    404: Error404

  }
  const CurrentPage = components[match.params.page] || components['404'];

  return(
    <Container fluid className={"App " + match.params.page}>
      <Navigation  page={match.params.page} />
      <CurrentPage />
      <Footer />
    </Container>
  )
}

const ScenarioOverview = ({ match }) => (
  <Container fluid className="App">
    <Navigation />
    <Scenario scenario={match.params.scenarioSlug} />
    <Row>
      <Col>
        <h3 className="exploreScenarios">{Strings.ExploreOtherScenarios}</h3>
      </Col>
    </Row>
    <Scenarios scenario={match.params.scenarioSlug} />
    <Footer />
  </Container>
)

const PhaseView = ({ match }) => (
  <Container fluid className="App">
    <Navigation />
    <Phase scenario={match.params.scenarioSlug} phase={match.params.phaseNr} />
    <Row>
      <Col>
        <h3 className="exploreScenarios">{Strings.ExploreOtherScenarios}</h3>
      </Col>
    </Row>
    <Scenarios scenario={match.params.scenarioSlug} />
    <Footer />
  </Container>
)

const Print = ({ match }) => (
  <Container fluid className="App print">
    <Navigation />
    <Scenario scenario={match.params.scenarioSlug} />
    <Phase scenario={match.params.scenarioSlug} phase='1' />
    <Phase scenario={match.params.scenarioSlug} phase='2' />
    <Phase scenario={match.params.scenarioSlug} phase='3' />
    <Phase scenario={match.params.scenarioSlug} phase='4' />
    <Footer />
  </Container>
)

class App extends Component {

  componentDidMount() {
//    console.log('View --> ', this.props.view);
//    console.log('Scenario --> ', this.props.scenario);
//    console.log('Phase --> ', this.props.phase);
  }

  render() {
    return(

      <Router>
        <ScrollToTop>

{/*
        <DataContext.Consumer>
          {({ status }) => (
            <div>Data status: {status}</div>
          )}
        </DataContext.Consumer>

*/}
        <Helmet>
          <title>{Strings.Meta_PageTitle}</title>
          <meta name="description" content={Strings.Meta_Description} />
        </Helmet>

          <Switch>
            <Route path="/s/:scenarioSlug/phase-:phaseNr" component={PhaseView} />
            <Route path="/s/:scenarioSlug" component={ScenarioOverview} />
            <Route path="/p/:scenarioSlug" component={Print} />
            <Route path="/:page" component={Page} />
            <Route exact={true} path="/" component={Home} />
          </Switch>
        </ScrollToTop>
      </Router>
    )
  }
}
export default App;





// WEBPACK FOOTER //
// ./src/App.js